var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 0.25C1.73122 0.25 0.5 1.48122 0.5 3C0.5 4.51878 1.73122 5.75 3.25 5.75C4.76878 5.75 6 4.51878 6 3C6 1.48122 4.76878 0.25 3.25 0.25Z",
    fill: "#2D264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 0.25C9.73122 0.25 8.50001 1.48122 8.50001 3C8.50001 4.51878 9.73122 5.75 11.25 5.75C12.7688 5.75 14 4.51878 14 3C14 1.48122 12.7688 0.25 11.25 0.25Z",
    fill: "#2D264B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 0.25C17.7312 0.25 16.5 1.48122 16.5 3C16.5 4.51878 17.7312 5.75 19.25 5.75C20.7688 5.75 22 4.51878 22 3C22 1.48122 20.7688 0.25 19.25 0.25Z",
    fill: "#2D264B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 8.25C1.73122 8.25 0.5 9.48122 0.5 11C0.5 12.5188 1.73122 13.75 3.25 13.75C4.76878 13.75 6 12.5188 6 11C6 9.48122 4.76878 8.25 3.25 8.25Z",
    fill: "#2D264B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 8.25C9.73122 8.25 8.5 9.48122 8.5 11C8.5 12.5188 9.73122 13.75 11.25 13.75C12.7688 13.75 14 12.5188 14 11C14 9.48122 12.7688 8.25 11.25 8.25Z",
    fill: "#2D264B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 8.25C17.7312 8.25 16.5 9.48122 16.5 11C16.5 12.5188 17.7312 13.75 19.25 13.75C20.7688 13.75 22 12.5188 22 11C22 9.48122 20.7688 8.25 19.25 8.25Z",
    fill: "#2D264B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 16.25C1.73122 16.25 0.5 17.4812 0.5 19C0.5 20.5188 1.73122 21.75 3.25 21.75C4.76878 21.75 6 20.5188 6 19C6 17.4812 4.76878 16.25 3.25 16.25Z",
    fill: "#2D264B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 16.25C9.73122 16.25 8.50001 17.4812 8.50001 19C8.50001 20.5188 9.73122 21.75 11.25 21.75C12.7688 21.75 14 20.5188 14 19C14 17.4812 12.7688 16.25 11.25 16.25Z",
    fill: "#2D264B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 16.25C17.7312 16.25 16.5 17.4812 16.5 19C16.5 20.5188 17.7312 21.75 19.25 21.75C20.7688 21.75 22 20.5188 22 19C22 17.4812 20.7688 16.25 19.25 16.25Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMenu);
export default __webpack_public_path__ + "static/media/phone-menu.4950c8974a0720fc7c6643eb85367ce4.svg";
export { ForwardRef as ReactComponent };